

















import {Component, Vue, Prop, Watch, Emit} from "vue-property-decorator";
import ajaxHelperInstance from "@/lib/ajaxhelper";
import {EMPTY_OBJECT} from "@/lib/appconst";

export enum objectTypeEnum {
    '知识库收藏' = 1,
    '文档点赞',
    '回答点赞',
    '提问收藏',
    '点击次数'
}

@Component({name: 'articleOperationBar'})
export default class articleOperationBar extends Vue {
    @Prop({type: Number, default: 0}) count?: number;
    @Prop({type: String, default: ''}) objectId: string;
    @Prop({type: String, default: ''}) type?: string;
    @Prop({type: String, default: ''}) icon: string;
    @Prop({type: Boolean, default: false}) active: boolean;
    @Prop({type: Boolean, default: false}) disabled?: boolean;
    @Prop({type: Boolean, default: false}) def?: boolean;
    @Prop({type: Object, default: EMPTY_OBJECT}) activeStyle?: object;

    operationCount: number = this.count;
    isActive: boolean = this.active;

    isDisabled: boolean = false;

    get getIcon() {
        return this.icon;
    }

    //更新操作数据
    handleUpdateOperation(objectType: string) {
        if (!objectType) {
            this.handleClick();
            return;
        }
        if (!this.objectId) {
            return;
        }
        let param = {
            objectId: this.objectId,
            objectType: objectType
        };

        let _this = this;
        ajaxHelperInstance.get('/web/user/oper', param).then((res) => {
            let {status, data} = res;
            let {errno} = data;
            if (status === 200 && errno === 0) {
                if (objectType === objectTypeEnum.点击次数.toString()) {
                    _this.operationCount++;
                } else {
                    _this.isActive = !_this.isActive;
                    if (_this.isActive) {
                        _this.operationCount++;
                    } else {
                        if (_this.operationCount > 0) {
                            _this.operationCount--;
                        }
                    }
                }
            }
        });
    }

    @Watch('objectId')
    handleObjectIdCount(newVal: string, oldVal: string) {
        if (this.type === objectTypeEnum.点击次数.toString()) {
            this.isDisabled = true;
            this.handleUpdateOperation(this.type);
        }
    }

    @Watch('count')
    handleChangeCount(newVal: number, oldVal: number) {
        this.operationCount = newVal;
    }

    @Watch('active')
    handleChangeActive(newVal: boolean, oldVal: boolean) {
        this.isActive = newVal;
    }

    @Emit('click')
    handleClick() {
        return this;
    }
}
